import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import url from '../constants/config';
import './ThreadQuill.css';

export function useDraftSummaries() {
  const { userEmail, userRole } = useSelector(state => state.authorization);
  const [summaries, setSummaries] = useState({});
  useEffect(() => {
    let active = true;
    setSummaries({});
    const load = async () => {
      if (!userEmail || !userRole) return;
      try {
        const response = await axios.get(`${url}/message-drafts`, { headers: { Authorization: `Bearer ${window.localStorage.getItem('authorization')}` } });
        if (active) setSummaries(Object.fromEntries(response.data.map(d => [`${d.threadType}:${d.conversationId}`, true])));
      } catch { /* A draft outage must not hide the existing inbox. */ }
    };
    load();
    window.addEventListener('message-draft-changed', load);
    const timer = setInterval(load, 15000);
    return () => { active = false; clearInterval(timer); window.removeEventListener('message-draft-changed', load); };
  }, [userEmail, userRole]);
  return summaries;
}

export default function DraftBadge({ summaries, threadType, conversationId }) {
  return summaries[`${threadType}:${conversationId}`] ? <span className="draft-badge">Wersja robocza</span> : null;
}
